<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb"></sm-page-header>

    <div class="content">
        <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [totalRecords]="totalRecords" [loading]="loading"></sm-data-table-builder>
    </div>
    <sm-drawer #addBlackList [drawer]="addDrawer"></sm-drawer>
    <sm-drawer #updateBlackList [drawer]="updateDrawer"></sm-drawer>
</div>